<template>
  <div class="slider__wrap glide" ref="sliderRef">
    <a
      @click="prevPage"
      class="slider__navigate-page slider__navigate-page--prev"
      ><i class="fas fa-angle-left"></i
    ></a>
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides" ref="slides">
        <slot></slot>
      </ul>
    </div>
    <a
      @click="nextPage"
      class="slider__navigate-page slider__navigate-page--next"
      ><i class="fas fa-angle-right"></i
    ></a>
  </div>
</template>

<script>
import Glide from "@glidejs/glide";

const breakpoints_default = {
  1000: { perView: 3 },
  800: { perView: 2 },
  500: { perView: 1 }
};
const breakpoints_ads = {
  1200: { perView: 3 },
  950: { perView: 2 },
  660: { perView: 1 }
};

export default {
  name: "Slider",

  props: {
    loading: Boolean,
    error: Object,
    length: Number,
    hasAds: {
      type: Boolean,
      required: false,
      default: false
    },
    lengthAds: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      glideInstance: null
    };
  },

  methods: {
    prevPage() {
      const glide = this.glideInstance;
      const activeSlide = glide.index;
      const perView = glide.settings.perView;
      const sliderIndexesLength = this.$refs.slides.childNodes.length;

      const prevSlide = activeSlide - perView;

      if (prevSlide <= -perView) {
        glide.go(`=${sliderIndexesLength - perView}`);
      } else if (prevSlide < 0) {
        glide.go(`=0`);
      } else {
        glide.go(`=${prevSlide}`);
      }
    },

    nextPage() {
      const glide = this.glideInstance;
      const activeSlide = glide.index;
      const perView = glide.settings.perView;
      const sliderIndexesLength = this.$refs.slides.childNodes.length;

      const nextSlide = activeSlide + perView;

      if (nextSlide >= sliderIndexesLength) {
        glide.go(`=0`);
      } else if (nextSlide >= sliderIndexesLength - perView) {
        glide.go(`=${sliderIndexesLength - perView}`);
      } else {
        glide.go(`=${nextSlide}`);
      }
    }
  },
  mounted: function() {
    this.glideInstance = new Glide(this.$refs.sliderRef, {
      type: "slider",
      perView: 4,
      bound: true,
      gap: 0,
      breakpoints: this.hasAds ? breakpoints_ads : breakpoints_default
    });
    this.glideInstance.mount();
  },
  watch: {
    length() {
      // Makes sure the DOM has time to update before refreshing slider
      setTimeout(() => {
        this.glideInstance.mount();
      }, 0); // timeout 0 - end of call stack
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@glidejs/glide/src/assets/sass/glide.core";

.slider {
  display: flex;
  flex-flow: row nowrap;

  &__wrap {
    position: relative;
    width: calc(100% - 100px);
    margin: 0 auto;

    &:before,
    &:after {
      content: " ";
      top: 0;
      bottom: 0;
      position: absolute;
      z-index: 2;
      width: 1px;
      box-shadow: 0px 0px 10px 0px $dashboard-background;
    }

    &:before {
      left: 0;
    }

    &:after {
      left: 0;
    }
  }

  &__navigate-page {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: $card-background-color;
    border: 1px solid #dddddd;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
    text-align: center;
    line-height: 28px;
    font-size: 20px;
    top: calc(50% - 15px);
    cursor: pointer;

    &--prev {
      left: -40px;

      > i {
        margin-right: 2px;
      }
    }

    &--next {
      right: -40px;

      > i {
        margin-left: 2px;
      }
    }
  }
}
</style>
